import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const videoPartner = {
  fetchVideoPartners: lazyModuleMethod(
    () => import('./fetchVideoPartners'),
    'default'
  ),
  createVideoPartner: lazyModuleMethod(
    () => import('./createVideoPartner'),
    'default'
  ),
}
